import { render, staticRenderFns } from "./GenericItem.vue?vue&type=template&id=bb878e2e"
import script from "./GenericItem.vue?vue&type=script&lang=js"
export * from "./GenericItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports